import {Link, Page} from '.';

export type Rule = {
  title: string;
  complexCheck: any;
  description: string;
  platforms: any;
  version: number;
  rationales: string[];
  fixtexts: string[];
  checks: Record<string, any>[];
  idents: any;
  __id: string;
  __severity: string;
  __role: string;
  __weight: number;
  __selected: boolean;
  assessedAssets: number;
  assetCompliance: number;
  passingAssets: number;
  ruleNaturalId: string;
};

export type RuleFindings = {
  assetKey: string;
  benchmarkNaturalId: string;
  benchmarkVersion: string;
  hostName: string;
  overridden: boolean;
  ip: string;
  lastPolicyAssessmentTime: string;
  links: any[];
  profileNaturalId: string;
  ruleNaturalId: string;
  policyResultStatus: RuleFindingsStatuses;
};

export enum RuleFindingsStatuses {
  PASS = 'PASS',
  FAIL = 'FAIL',
}

export type RuleFindingsResponse = {
  links: Link[];
  page: Page;
  resources: RuleFindings[];
};

export enum RuleDataKey {
  ASSET_COMPLIANCE = 'assetCompliance',
  TITLE = 'title',
  POLICY_RESULT_STATUS = 'policyResultStatus',
  IS_OVERRIDEN = 'overridden',
}

export enum RuleDetailsTabViews {
  ASSETS = 'assets',
  OVERRIDES = 'overrides',
}

export type RuleFindingmetrics = {
  date: string;
  fields: Record<string, any> | null;
  fullSegment: string | null;
  metrics: {[key: string]: number};
  segment: string | null;
};

export type RuleDetails = {
  customizableValues: any[];
  description: string;
  fixtext: string;
  id: string;
  rationale: string;
  role: string;
  selected: boolean;
  severity: string;
  title: string;
  weight: number;
  _isCpe: boolean;
};
